// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1_DMb","cls2":"SimplePaperPodcast-cls2_pzK SimplePaperPodcast-cls1_DMb"};